import React, { useState } from 'react';

import styled from '@emotion/styled';

import { DownChevron } from '../Icons/DownChevron';
import UpChevron from '../Icons/UpChevron';
import { NavLink } from '../Link/Link';

export interface INavConfigListData {
  label: string;
  link: string;
}

interface IHeaderCollapsibleSegment {
  title: string;
  data?: INavConfigListData[];
  className?: string;
  onClick: (...args: any) => void;
}

const HeaderCollapsibleSegment: React.FC<IHeaderCollapsibleSegment> = ({
  title,
  data,
  className,
  onClick,
}) => {
  const [showContent, setShowContent] = useState(false);

  const handleShowContent = () => {
    setShowContent(!showContent);
  };

  return (
    <Container>
      <TitleArea onClick={() => handleShowContent()}>
        <Title
          className={className === 'hamburger-menu' ? 'hamburger-menu' : ''}
        >
          {title}
        </Title>
        {showContent ? <UpChevron /> : <DownChevron />}
      </TitleArea>
      <RevealContent className={showContent ? 'reveal' : ''}>
        {data?.map((item, index) => {
          return (
            <NavLink key={index} to={item.link} onClick={onClick}>
              <LabelWrapper>
                <Label>{item.label}</Label>
              </LabelWrapper>
            </NavLink>
          );
        })}
      </RevealContent>
    </Container>
  );
};

export default HeaderCollapsibleSegment;

const Container = styled.div`
  display: None;
  flex-direction: column;
  gap: 1rem;
  color: ${({ theme }) => theme.palette.darkTextColor};
  width: 180px;

  @media (max-width: 884px) {
    display: flex;
  }
`;

const LabelWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  margin-left: 10px;
`;

const Label = styled.div`
  color: #504b49;
  font-size: 0.875rem;
  font-weight: 500;

  &:hover {
    color: black;
  }
`;

const TitleArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  margin-right: 40px;
`;

const Title = styled.div`
  font-weight: 600;
  font-size: 1rem;
  color: black;

  &:hover {
    color: #000000a7;
  }
`;

const RevealContent = styled.div`
  display: none;
  flex-direction: column;
  gap: 1.5rem;
  height: 0;
  transition: all 0.2s ease;

  &.reveal {
    height: fit-content;
    display: flex;
  }
`;
